import { emitViewEvent } from './emitter';

const buildWidgetTrackingData = (widgetTracking, featureIndex) => {
  const { labels } = widgetTracking;
  const featureNumber = 99;
  return {
    ...widgetTracking,
    position: Number(featureIndex),
    status: 'loaded',
    labels: {
      ...labels,
      promo_FeatureNumber: [`${featureNumber}`]
    }
  };
};
const buildProductTrackingData = (productTracking) => ({
  ...productTracking,
  status: 'loaded'
});

const track = (widgetTracking, productsTracking, featureIndex, eventMergeId = null) => {
  const productEvents = productsTracking.map((it) => buildProductTrackingData(it));
  const event = [buildWidgetTrackingData(widgetTracking, featureIndex), ...productEvents];
  emitViewEvent(event, eventMergeId);
};

export default track;
